import React from 'react';
import { Navigation, Footer } from './Navigation';
import { useState } from 'react';

export function Feature2(props) {

    const [inputtedSongArray, setInputtedSongArray] = useState([]);

    const [inputtedSongOne, setInputtedSongOne] = useState('');
    const [inputtedSongTwo, setInputtedSongTwo] = useState('');
    const [inputtedSongThree, setInputtedSongThree] = useState('');
    const [inputtedSongFour, setInputtedSongFour] = useState('');
    const [inputtedSongFive, setInputtedSongFive] = useState('');
    const [inputtedSongSix, setInputtedSongSix] = useState('');
    const [inputtedSongSeven, setInputtedSongSeven] = useState('');
    const [inputtedSongEight, setInputtedSongEight] = useState('');


    const [choiceOne, setChoiceOne] = useState('Type in your song choice first!');
    const [choiceTwo, setChoiceTwo] = useState('Type in your song choice first!');
    const [choiceThree, setChoiceThree] = useState('Type in your song choice first!');
    const [choiceFour, setChoiceFour] = useState('Type in your song choice first!');

    const [winnerOne, setWinnerOne] = useState('Select!');
    const [winnerTwo, setWinnerTwo] = useState('Select!');

    const handleChangeOne = (event) => {
        const value = event.target.value;
        setInputtedSongOne(value);
    }

    const handleChangeTwo = (event) => {
        const value = event.target.value;
        setInputtedSongTwo(value);
    }

    const handleChangeThree = (event) => {
        const value = event.target.value;
        setInputtedSongThree(value);
    }

    const handleChangeFour = (event) => {
        const value = event.target.value;
        setInputtedSongFour(value);
    }

    const handleChangeFive = (event) => {
        const value = event.target.value
        setInputtedSongFive(value);
    }

    const handleChangeSix = (event) => {
        const value = event.target.value;
        setInputtedSongSix(value);
    }

    const handleChangeSeven = (event) => {
        const value = event.target.value;
        setInputtedSongSeven(value);
    }

    const handleChangeEight = (event) => {
        const value = event.target.value;
        setInputtedSongEight(value);
    }

    const clickPairOne = () => {
        setInputtedSongArray([...inputtedSongArray, inputtedSongOne, inputtedSongTwo]);
    }

    const clickPairTwo = () => {
        setInputtedSongArray([...inputtedSongArray, inputtedSongThree, inputtedSongFour]);
    }

    const clickPairThree = () => {
        setInputtedSongArray([...inputtedSongArray, inputtedSongFive, inputtedSongSix]);
    }

    const clickPairFour = () => {
        setInputtedSongArray([...inputtedSongArray, inputtedSongSeven, inputtedSongEight]);
    }

    const roundTwoPairOne = (event) => {
        const value = event.target.value;
        setChoiceOne(value);
    }

    const roundTwoPairTwo = (event) => {
        const value = event.target.value;
        setChoiceTwo(value);
    }

    const roundTwoPairThree = (event) => {
        const value = event.target.value;
        setChoiceThree(value);
    }

    const roundTwoPairFour = (event) => {
        const value = event.target.value;
        setChoiceFour(value);
    }

    const winnerTop = (event) => {
        const value = event.target.value;
        setWinnerOne(value);
    }

    const winnerBottom = (event) => {
        const value = event.target.value;
        setWinnerTwo(value);
    }

    function RoundOne() {

        return (
            <div className="round">
                <h2>Round One</h2>
                <div className="dropdown start-item">
                    <form>
                        <select id="filterSelect" className="form-select" value={choiceOne} onChange={roundTwoPairOne} >
                            <option>Select!</option>
                            <option>{inputtedSongArray[0]}</option>
                            <option>{inputtedSongArray[1]}</option>
                        </select>
                    </form>
                </div>
                <div className="dropdown start-item">
                    <form>
                        <select id="filterSelect" className="form-select" value={choiceTwo} onChange={roundTwoPairTwo} >
                            <option>Select!</option>
                            <option>{inputtedSongArray[2]}</option>
                            <option>{inputtedSongArray[3]}</option>
                        </select>
                    </form>
                </div>
                <div className="dropdown start-item">
                    <form>
                        <select id="filterSelect" className="form-select" value={choiceThree} onChange={roundTwoPairThree} >
                            <option>Select!</option>
                            <option>{inputtedSongArray[4]}</option>
                            <option>{inputtedSongArray[5]}</option>
                        </select>
                    </form>
                </div>
                <div className="dropdown start-item">
                    <form>
                        <select id="filterSelect" className="form-select" value={choiceFour} onChange={roundTwoPairFour} >
                            <option>Select!</option>
                            <option>{inputtedSongArray[6]}</option>
                            <option>{inputtedSongArray[7]}</option>
                        </select>
                    </form>
                </div>
            </div>
        );
    }

    function RoundTwo() {
        return (
            <div className="round">
                <h2>Round Two</h2>
                <div className="dropdown start-item">
                    <form>
                        <select id="filterSelect" className="form-select" value={winnerOne} onChange={winnerTop} >
                            <option>Select!</option>
                            <option>{choiceOne}</option>
                            <option>{choiceTwo}</option>
                        </select>
                    </form>
                </div>
                <div className="dropdown start-item">
                    <form>
                        <select id="filterSelect" className="form-select" value={winnerTwo} onChange={winnerBottom} >
                            <option>Select!</option>
                            <option>{choiceThree}</option>
                            <option>{choiceFour}</option>
                        </select>
                    </form>
                </div>
            </div>
        );
    }

    function Winner() {
        return (
            <div className="round">
                <h2>Winner!</h2>
                <div className="dropdown start-item">
                    <form>
                        <select id="filterSelect" className="form-select" >
                            <option>Select!</option>
                            <option>{winnerOne}</option>
                            <option>{winnerTwo}</option>
                        </select>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Navigation />

            <header>
                <h1>Pop Playoffs!</h1>
            </header>

            <main>
                <p className="instructions card">To create your personalized bracket first type in the pairs of songs you want and click submit. Then, select the winner from each pair in the drop down menus!</p>
                <div className="container-fluid col-sm-6 col-md-3 d-flex">

                    {/* <div className="col-sm-6 d-flex"> */}

                    <div className="round">
                        <h2>Input Your Song Choices!</h2>
                        <div className="matchup">
                            <div>
                                <textarea placeholder="Song Name" onChange={handleChangeOne} value={inputtedSongOne} >
                                </textarea>
                            </div>
                            <div>
                                <textarea placeholder="Song Name" onChange={handleChangeTwo} value={inputtedSongTwo} >
                                </textarea>
                            </div>
                            <div>
                                <button className="button-1" onClick={clickPairOne}>Submit!</button>
                            </div>
                        </div>

                        <div className="matchup">
                            <div>
                                <textarea placeholder="Song Name" onChange={handleChangeThree} value={inputtedSongThree} >
                                </textarea>
                            </div>
                            <div>
                                <textarea placeholder="Song Name" onChange={handleChangeFour} value={inputtedSongFour} >
                                </textarea>
                            </div>
                            <div>
                                <button className="button-1" onClick={clickPairTwo}>Submit!</button>
                            </div>
                        </div>

                        <div className="matchup">
                            <div>
                                <textarea placeholder="Song Name" onChange={handleChangeFive} value={inputtedSongFive} >
                                </textarea>
                            </div>
                            <div>
                                <textarea placeholder="Song Name" onChange={handleChangeSix} value={inputtedSongSix} >
                                </textarea>
                            </div>
                            <div>
                                <button className="button-1" onClick={clickPairThree}>Submit!</button>
                            </div>
                        </div>

                        <div className="matchup">
                            <div>
                                <textarea placeholder="Song Name" onChange={handleChangeSeven} value={inputtedSongSeven} >
                                </textarea>
                            </div>
                            <div>
                                <textarea placeholder="Song Name" onChange={handleChangeEight} value={inputtedSongEight} >
                                </textarea>
                            </div>
                            <div>
                                <button className="button-1" onClick={clickPairFour}>Submit!</button>
                            </div>
                        </div>
                    </div>

                    {/* </div> */}

                    <div className="col-sm-6 col-md-3 d-flex">
                        <RoundOne />
                    </div>

                    <div className="col-sm-6 col-md-3 d-flex">
                        <RoundTwo />
                    </div>

                    <div className="col-sm-6 col-md-3 d-flex">
                        <Winner />
                    </div>

                </div>

            </main>

            <Footer />

        </div>
    );
}